import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'
import { ErrorOutlineRounded } from '@mui/icons-material'
import { ChecklistDocument } from '@black-bear-energy/black-bear-energy-common'
import { rucksack } from '@black-bear-energy/rucksack'

export const DocumentStatusChip: FunctionComponent<DocumentStatusChipProps> = ({
  document,
}) => {
  let statusLabel: string
  let chipVariant: 'filled' | 'outlined' = 'filled'
  let statusSx: {
    color?: string
    backgroundColor?: string
    border?: string
    fontWeight?: number
  }
  let chipIcon = undefined

  const isRejected =
    document.review && !document.review.outdated && !document.review.verified

  if (!document.uploaded) {
    if (document.required) {
      statusLabel = 'Required'
      chipVariant = 'outlined'
      statusSx = {
        border: `1px solid ${rucksack.palette.error.main}`,
        color: rucksack.palette.error.dark,
      }
    } else {
      statusLabel = 'No Upload'
      statusSx = {
        backgroundColor: 'rgba(32, 43, 57, 0.08)',
        color: rucksack.palette.text.primary,
      }
    }
  } else if (isRejected) {
    if (document.required) {
      statusLabel = 'Rejected - Required'
      statusSx = {
        backgroundColor: rucksack.palette.error.chipFill,
        color: rucksack.palette.error.chipLabel,
        fontWeight: 600,
      }
      chipIcon = (
        <ErrorOutlineRounded
          style={{ color: rucksack.palette.error.chipLabel }}
        />
      )
    } else {
      statusLabel = 'Rejected'
      statusSx = {
        backgroundColor: 'rgba(32, 43, 57, 0.08)',
        color: rucksack.palette.text.primary,
      }
      chipIcon = (
        <ErrorOutlineRounded style={{ color: rucksack.palette.text.primary }} />
      )
    }
  } else {
    statusLabel = 'Uploaded'
    statusSx = {
      backgroundColor: rucksack.palette.success.chipFill,
      color: rucksack.palette.success.chipLabel,
    }
  }

  return (
    <Chip
      icon={chipIcon}
      variant={chipVariant}
      label={statusLabel}
      size="small"
      sx={statusSx}
    />
  )
}

interface DocumentStatusChipProps {
  document: ChecklistDocument
}
